import dotenv from "dotenv";
dotenv.config();

const { REACT_APP_API_BASEURL: API_BASEURL } = process?.env;

export const URL_SEARCH_BY_NAME = `${API_BASEURL}/countries?name=`;

export const URL_SEARCH_BY_ACTIVITY = `${API_BASEURL}/countries/activity?activity=`;

export const URL_GET_ALL_COUNTRIES = `${API_BASEURL}/countries`;

export const URL_GET_COUNTRY = `${API_BASEURL}/countries/`;

export const URL_POST_ACTIVITY = `${API_BASEURL}/activity`;

export const URL_GET_ALL_CONTINENTS = `${API_BASEURL}/continent`;

export const URL_GET_COUNTRIES_BY_CONTINENT = `${API_BASEURL}/continent/`;

export const TEMPORADAS = ["Invierno", "Verano", "Otoño", "Primavera"];
